import { RoleEnum } from '@/types/authent/roles.types';
import { ActionEnum } from '@/types/commons/commons.types';

export enum CockpitPanelIntlKeysEnum {
  NOTIFICATION = 'NOTIFICATION',
  LOG_BOOK_AND_CHAT = 'LOG_BOOK_AND_CHAT',
  OPERATOR_STATION_CONFIGURATION = 'OPERATOR_STATION_CONFIGURATION',
  SENSOR_INSTALLATION = 'SENSOR_INSTALLATION',
  SETTINGS = 'SETTINGS',
  ORGANIZATION = 'ORGANIZATION',
  PLATFORM = 'PLATFORM',
  ZONE = 'ZONE',
  USERS_MANAGEMENT = 'USERS_MANAGEMENT',
  MONITORING = 'MONITORING',
  NOTIFICATION_SEARCH = 'NOTIFICATION_SEARCH',
  SYSTEM_PARAMETERS = 'SYSTEM_PARAMETERS',
  DRONES_FLEET = 'DRONES_FLEET',
  FLIGHT_PLANS = 'FLIGHT_PLANS',
}

export const LOGBOOK_ROLES = [
  RoleEnum.ACCESS_INSTRUCTION,
  RoleEnum.ACCESS_SYSTEM_LOG,
  RoleEnum.ACCESS_REPLAY,
  RoleEnum.ACCESS_USER_ACTION,
];
export const SEE_NOTIFICATIONS_ROLES = [ActionEnum.ACCESS_TARGET, ActionEnum.MAINTAIN];
export const SEE_ZONE_ROLES = [RoleEnum.ACCESS_ZONE_IMZ, RoleEnum.ACCESS_ZONE_NFZ, RoleEnum.ACCESS_ZONE_NIZ];
export const USERS_MANAGEMENT_ROLES = [RoleEnum.ACCESS_USER, RoleEnum.ACCESS_GROUP, RoleEnum.ACCESS_PROFILE];
export const SEE_SENSOR_INSTALLATION_ROLES = [ActionEnum.ACCESS, ActionEnum.CREATE, ActionEnum.EDIT, ActionEnum.DELETE];
const ADMINISTRATOR_ROLES = [
  RoleEnum.ACCESS_GLOBAL_SCREEN_CONFIGURATION,
  RoleEnum.EDIT_GLOBAL_SCREEN_CONFIGURATION,
  RoleEnum.CREATE_GLOBAL_SCREEN_CONFIGURATION,
  RoleEnum.DELETE_GLOBAL_SCREEN_CONFIGURATION,
];
export const UTM_ROLES = [RoleEnum.ACCESS_DRONE, RoleEnum.ACCESS_PILOT];

export type PermissionConfig =
  | { type: 'roles'; roles: RoleEnum[] }
  | { type: 'actionSensor'; roles: ActionEnum[] }
  | { type: 'roleSingle'; role: RoleEnum };

export const permissionsConfig: Partial<Record<CockpitPanelIntlKeysEnum, PermissionConfig>> = {
  NOTIFICATION: {
    type: 'actionSensor',
    roles: SEE_NOTIFICATIONS_ROLES,
  },
  NOTIFICATION_SEARCH: {
    type: 'actionSensor',
    roles: SEE_NOTIFICATIONS_ROLES,
  },
  SENSOR_INSTALLATION: {
    type: 'actionSensor',
    roles: SEE_SENSOR_INSTALLATION_ROLES,
  },
  USERS_MANAGEMENT: {
    type: 'roles',
    roles: USERS_MANAGEMENT_ROLES,
  },
  LOG_BOOK_AND_CHAT: {
    type: 'roles',
    roles: [RoleEnum.ACCESS_MSG, ...LOGBOOK_ROLES],
  },
  ORGANIZATION: {
    type: 'roleSingle',
    role: RoleEnum.ACCESS_ORGANIZATION,
  },
  FLIGHT_PLANS: {
    type: 'roleSingle',
    role: RoleEnum.ACCESS_FLIGHT_PLAN,
  },
  ZONE: {
    type: 'roles',
    roles: SEE_ZONE_ROLES,
  },
  PLATFORM: {
    type: 'roleSingle',
    role: RoleEnum.ACCESS_PLATFORM,
  },
  DRONES_FLEET: {
    type: 'roles',
    roles: UTM_ROLES,
  },
  OPERATOR_STATION_CONFIGURATION: {
    type: 'roles',
    roles: ADMINISTRATOR_ROLES,
  },
  MONITORING: {
    type: 'actionSensor',
    roles: [ActionEnum.MAINTAIN],
  },
};
